<div
  class="modal-close extend-click-area"
  (click)="close()">
  <app-icon name="close"></app-icon>
</div>

<ng-container *transloco="let t">
  <div class="modal-header">
    <h3
      class="modal-title"
      [innerHTML]="t(popupOptions.titleKey)"></h3>
  </div>

  <div class="modal-body __s">
    <span [innerHTML]="t(popupOptions.descriptionKey, popupOptions.descriptionValues)"></span>

    <div style="margin-top: 24px">
      <button
        [ngClass]="popupOptions.confirmButtonClasses"
        (click)="confirm()"
        [innerHTML]="t(popupOptions.confirmButtonKey)"></button>
    </div>
  </div>
</ng-container>
